import config from "../config";
import type { APIConfigType } from "./types";

const { baseApiURL } = config;

export const API_CONFIG = {
  signup: {
    client: "/api/sign",
    back: `${baseApiURL}v1/sign/request`,
  },
};

export const COLLABORATION_AGENCY_API_CONFIG: APIConfigType<typeof API_CONFIG> =
  API_CONFIG;
